import { useEffect, type ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { Logo } from './ui'

/** The frame of public show and episode pages: no sign-in, no app chrome. */
export function PublicLayout({ title, children }: { title?: string; children: ReactNode }) {
  useEffect(() => {
    if (title) document.title = title
  }, [title])
  return (
    <div className="public">
      <main className="public-main">{children}</main>
      <footer className="public-footer">
        <Link to="/" className="brand">
          <Logo size={18} /> Streamed with indiefuture
        </Link>
      </footer>
    </div>
  )
}
